import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { SecondaryButton } from 'components/Button';
import { Header } from 'components/Text';
import { HOME } from 'routes/home/paths';
import { REGISTER_VEHICLE_SUMMARY } from 'routes/overview/RegisterVehicle/paths';
import { TRANSFER_TAG_SUMMARY } from 'routes/overview/TransferTag/paths';
import useStyles from './SummaryPageStyles';
export default function SummaryPage({
  header,
  children
}) {
  const {
    push
  } = useHistory();
  const {
    t
  } = useTranslation();
  const {
    backButton,
    summary
  } = useStyles();
  const onRegisterVehicleSummary = useRouteMatch(REGISTER_VEHICLE_SUMMARY)?.isExact;
  const onTransferTagSummary = useRouteMatch(TRANSFER_TAG_SUMMARY)?.isExact;
  if (onRegisterVehicleSummary || onTransferTagSummary) {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: summary
    }, /*#__PURE__*/React.createElement(Header, {
      component: "h1"
    }, header), /*#__PURE__*/React.createElement("div", {
      className: backButton,
      style: {
        marginTop: 0
      }
    }, /*#__PURE__*/React.createElement(SecondaryButton, {
      onClick: () => push(HOME)
    }, t('buttons.back_to_main_page')))), children);
  }
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Header, {
    component: "h1"
  }, header), children, /*#__PURE__*/React.createElement("div", {
    className: backButton
  }, /*#__PURE__*/React.createElement(SecondaryButton, {
    onClick: () => push(HOME)
  }, t('buttons.back_to_main_page'))));
}